/* ============================================================
   CASE ELEGANCE — PREMIUM COLLECTION JS
   Scroll reveals, header transition, gallery, sticky ATC,
   mobile menu, lightbox
   ============================================================ */

(function() {
  'use strict';

  function escapeHTML(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    var amount = typeof cents === 'number' ? cents : parseInt(cents, 10) || 0;
    return '$' + (amount / 100).toFixed(2);
  }

  /* --- SCROLL REVEAL (IntersectionObserver) --- */
  function initScrollReveals() {
    var reveals = document.querySelectorAll('.ce-reveal, .ce-reveal-stagger');
    if (!reveals.length) return;

    if (!('IntersectionObserver' in window)) {
      reveals.forEach(function(el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });

    reveals.forEach(function(el) {
      observer.observe(el);
    });
  }


  /* --- HEADER SCROLL TRANSITION --- */
  function initHeader() {
    var header = document.querySelector('.ce-header');
    if (!header) return;

    var hero = document.querySelector('.ce-hero');
    var scrollThreshold = 20;

    function updateHeader() {
      var scrollY = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollY > scrollThreshold) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }

      if (hero) {
        var heroBottom = hero.offsetTop + hero.offsetHeight;
        if (scrollY < heroBottom - 72) {
          header.classList.add('is-on-hero');
        } else {
          header.classList.remove('is-on-hero');
        }
      }
    }

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          updateHeader();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    updateHeader();
  }


  /* --- PRODUCT GALLERY --- */
  function initGallery() {
    var gallery = document.querySelector('.ce-gallery');
    if (!gallery) return;

    var mainImage = gallery.querySelector('.ce-gallery__main img');
    var thumbs = gallery.querySelectorAll('.ce-gallery__thumb');
    var images = [];

    /* Preload all full-size images immediately */
    var preloaded = [];
    thumbs.forEach(function(thumb) {
      var src = thumb.getAttribute('data-full-src') || thumb.querySelector('img').src;
      images.push(src);
      var img = new Image();
      img.src = src;
      preloaded.push(img);
    });

    thumbs.forEach(function(thumb, index) {
      thumb.addEventListener('click', function() {
        setActiveImage(index);
      });
    });

    function setActiveImage(index) {
      if (!mainImage || !images[index]) return;

      /* Instant swap — no fade, no delay */
      mainImage.src = images[index];

      thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      if (thumbs[index]) thumbs[index].classList.add('is-active');

      thumbs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    if (thumbs.length > 0) {
      thumbs[0].classList.add('is-active');
    }

    /* PhotoSwipe Lightbox */
    var mainContainer = gallery.querySelector('.ce-gallery__main');
    var zoomBtn = gallery.querySelector('.ce-gallery__zoom-btn');

    function openPhotoSwipe(startIndex) {
      if (typeof window.PhotoSwipeLightbox === 'undefined' || typeof window.PhotoSwipe === 'undefined') return;

      var slides = [];
      thumbs.forEach(function(thumb) {
        slides.push({
          src: thumb.getAttribute('data-full-src'),
          width: parseInt(thumb.getAttribute('data-pswp-width')) || 2000,
          height: parseInt(thumb.getAttribute('data-pswp-height')) || 2000,
          alt: thumb.querySelector('img').alt
        });
      });

      if (!slides.length) return;

      var pswp = new window.PhotoSwipeLightbox({
        dataSource: slides,
        pswpModule: window.PhotoSwipe,
        bgOpacity: 0.95,
        padding: { top: 20, bottom: 20, left: 20, right: 20 },
        closeOnVerticalDrag: true,
        pinchToClose: true,
        initialZoomLevel: 'fit',
        secondaryZoomLevel: 1.2,
        maxZoomLevel: 1.5
      });
      pswp.init();
      pswp.loadAndOpen(startIndex || 0);
    }

    function getCurrentIndex() {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    if (mainContainer) {
      mainContainer.addEventListener('click', function(e) {
        if (e.target.closest('.ce-gallery__zoom-btn')) return;
        openPhotoSwipe(getCurrentIndex());
      });
    }

    if (zoomBtn) {
      zoomBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        openPhotoSwipe(getCurrentIndex());
      });
    }

    /* Carousel arrow navigation */
    var carouselTrack = document.getElementById('CarouselTrack');
    var prevBtn = document.getElementById('CarouselPrev');
    var nextBtn = document.getElementById('CarouselNext');

    if (carouselTrack && prevBtn && nextBtn) {
      function getSlideWidth() {
        var slide = carouselTrack.querySelector('.ce-carousel__slide');
        if (!slide) return 200;
        return slide.offsetWidth + 6; /* width + gap */
      }

      prevBtn.addEventListener('click', function() {
        if (carouselTrack.scrollLeft <= 0) {
          carouselTrack.scrollTo({ left: carouselTrack.scrollWidth, behavior: 'smooth' });
        } else {
          carouselTrack.scrollBy({ left: -getSlideWidth() * 4, behavior: 'smooth' });
        }
      });

      nextBtn.addEventListener('click', function() {
        var maxScroll = carouselTrack.scrollWidth - carouselTrack.clientWidth;
        if (carouselTrack.scrollLeft >= maxScroll - 5) {
          carouselTrack.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          carouselTrack.scrollBy({ left: getSlideWidth() * 4, behavior: 'smooth' });
        }
      });
    }

    /* Mobile swipe dots sync */
    var mobileScroll = gallery.querySelector('.ce-gallery__mobile-scroll');
    var dots = gallery.querySelectorAll('.ce-gallery__dot');

    if (mobileScroll && dots.length) {
      var scrollTimer;
      mobileScroll.addEventListener('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function() {
          var scrollLeft = mobileScroll.scrollLeft;
          var slideWidth = mobileScroll.offsetWidth;
          var activeIndex = Math.round(scrollLeft / slideWidth);

          dots.forEach(function(dot, i) {
            dot.classList.toggle('is-active', i === activeIndex);
          });
        }, 50);
      }, { passive: true });

      if (dots[0]) dots[0].classList.add('is-active');
    }
  }


  /* --- STICKY MOBILE ADD TO CART --- */
  function initStickyATC() {
    var stickyBar = document.querySelector('.ce-sticky-atc');
    var addToCartBtn = document.querySelector('.ce-product-form__submit');
    var purchasePanel = document.querySelector('.ce-purchase-panel');
    if (!stickyBar || !addToCartBtn || !purchasePanel) return;
    if (stickyBar.dataset.ceStickyAtcReady === 'true') return;
    stickyBar.dataset.ceStickyAtcReady = 'true';

    var root = document.documentElement;
    var body = document.body;
    var mq = window.matchMedia('(max-width: 989px)');
    var ticking = false;
    var lastVisibleState = null;
    var lastScrollY = window.pageYOffset || root.scrollTop || 0;
    var revealUntil = 0;
    var revealIdleTimer = null;

    function updateStickyHeight() {
      var height = Math.ceil(stickyBar.getBoundingClientRect().height || 0);
      if (height > 0) {
        root.style.setProperty('--ce-sticky-atc-height', height + 'px');
      }
    }

    function setStickyVisible(shouldShow) {
      if (lastVisibleState === shouldShow) return;
      lastVisibleState = shouldShow;
      stickyBar.classList.toggle('is-visible', shouldShow);
      root.classList.toggle('ce-sticky-atc-is-visible', shouldShow);
      body.classList.toggle('ce-sticky-atc-is-visible', shouldShow);
      stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      updateStickyHeight();
    }

    function evaluateStickyState() {
      ticking = false;

      if (!mq.matches) {
        revealUntil = 0;
        setStickyVisible(false);
        return;
      }

      var rect = purchasePanel.getBoundingClientRect();
      var viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      var panelIsVisible = rect.top < viewportHeight && rect.bottom > 0;
      var panelHasScrolledPastTop = rect.bottom <= 0;
      var hasRecentSwipeUp = Date.now() < revealUntil;

      setStickyVisible(panelHasScrolledPastTop && !panelIsVisible && hasRecentSwipeUp);
    }

    function queueEvaluate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(evaluateStickyState);
    }

    function handleScrollIntent() {
      var currentScrollY = window.pageYOffset || root.scrollTop || 0;
      var delta = currentScrollY - lastScrollY;
      lastScrollY = currentScrollY;

      if (delta > 6) {
        revealUntil = Date.now() + 1200;
        window.clearTimeout(revealIdleTimer);
        revealIdleTimer = window.setTimeout(queueEvaluate, 1250);
      } else if (delta < -6) {
        revealUntil = 0;
        window.clearTimeout(revealIdleTimer);
      }

      queueEvaluate();
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(queueEvaluate, {
        threshold: [0, 0.01, 0.5, 1]
      });
      observer.observe(purchasePanel);
      stickyBar.__ceStickyAtcObserver = observer;
    }

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(queueEvaluate);
      resizeObserver.observe(stickyBar);
      resizeObserver.observe(purchasePanel);
      stickyBar.__ceStickyAtcResizeObserver = resizeObserver;
    }

    window.addEventListener('scroll', handleScrollIntent, { passive: true });
    window.addEventListener('resize', queueEvaluate, { passive: true });
    window.addEventListener('orientationchange', queueEvaluate, { passive: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', queueEvaluate, { passive: true });
      window.visualViewport.addEventListener('scroll', queueEvaluate, { passive: true });
    }
    if (mq.addEventListener) {
      mq.addEventListener('change', queueEvaluate);
    } else if (mq.addListener) {
      mq.addListener(queueEvaluate);
    }

    updateStickyHeight();
    queueEvaluate();
  }


  /* --- MOBILE MENU --- */
  function initMobileMenu() {
    var hamburger = document.querySelector('.ce-hamburger');
    var mobileMenu = document.querySelector('.ce-mobile-menu');
    if (!hamburger || !mobileMenu) return;

    hamburger.addEventListener('click', function() {
      var isOpen = hamburger.classList.contains('is-open');

      if (isOpen) {
        hamburger.classList.remove('is-open');
        mobileMenu.classList.remove('is-open');
        document.body.style.overflow = '';
      } else {
        hamburger.classList.add('is-open');
        mobileMenu.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
    });

    mobileMenu.querySelectorAll('.ce-mobile-menu__link').forEach(function(link) {
      link.addEventListener('click', function() {
        hamburger.classList.remove('is-open');
        mobileMenu.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });
  }


  /* --- FEATURE IMAGE SCROLL SWAP --- */
  function initFeatureScrollSwap() {
    var items = document.querySelectorAll('.ce-feature-story__item[data-feature-index]');
    var images = document.querySelectorAll('.ce-feature-story__img[data-feature-img]');
    if (!items.length || !images.length) return;

    if (!('IntersectionObserver' in window)) {
      images[0].classList.add('is-active');
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var index = entry.target.getAttribute('data-feature-index');
          images.forEach(function(img) { img.classList.remove('is-active'); });
          var target = document.querySelector('.ce-feature-story__img[data-feature-img="' + index + '"]');
          if (target) target.classList.add('is-active');
        }
      });
    }, {
      threshold: 0.4,
      rootMargin: '-20% 0px -20% 0px'
    });

    items.forEach(function(item) { observer.observe(item); });
  }


  /* --- COLOR SWATCHES --- */
  function initSwatches() {
    var swatchContainers = document.querySelectorAll('.ce-swatches[data-option-index]');
    if (!swatchContainers.length) return;
    var productJSON = document.getElementById('PremiumProductJSON');
    var productData = productJSON ? JSON.parse(productJSON.textContent) : null;
    var variantInput = document.querySelector('.ce-product-form [name="id"]');

    swatchContainers.forEach(function(swatchContainer) {
      var swatches = swatchContainer.querySelectorAll('.ce-swatch');
      var selectedLabel = swatchContainer.querySelector('.ce-swatches__selected-label');
      var optionIndex = parseInt(swatchContainer.getAttribute('data-option-index'), 10);

      swatches.forEach(function(swatch) {
        swatch.addEventListener('click', function() {
          var value = swatch.getAttribute('data-option-value');

          swatches.forEach(function(s) { s.classList.remove('is-active'); });
          swatch.classList.add('is-active');

          if (selectedLabel) selectedLabel.textContent = value;

          if (productData && variantInput) {
            var selectedOptions = [];
            productData.options.forEach(function(opt, i) {
              if (i === optionIndex) {
                selectedOptions.push(value);
              } else {
                var otherSelector = document.querySelector('[data-option-index="' + i + '"]');
                if (otherSelector) {
                  if (otherSelector.classList.contains('ce-swatches')) {
                    var activeSwatch = otherSelector.querySelector('.ce-swatch.is-active');
                    selectedOptions.push(activeSwatch ? activeSwatch.getAttribute('data-option-value') : opt.values[0]);
                  } else if (otherSelector.tagName === 'SELECT') {
                    selectedOptions.push(otherSelector.value);
                  } else {
                    selectedOptions.push(opt.values[0]);
                  }
                } else {
                  selectedOptions.push(opt.values[0]);
                }
              }
            });

            var matchedVariant = productData.variants.find(function(v) {
              return selectedOptions.every(function(opt, i) {
                return v['option' + (i + 1)] === opt;
              });
            });

            if (matchedVariant) {
              variantInput.value = matchedVariant.id;

              var priceEl = document.querySelector('[data-product-price]') || document.querySelector('.ce-type-price');
              if (priceEl && matchedVariant.price) {
                priceEl.textContent = '$' + (matchedVariant.price / 100).toFixed(2);
              }

              var submitBtn = document.querySelector('.ce-product-form__submit');
              if (submitBtn) {
                if (matchedVariant.available) {
                  submitBtn.disabled = false;
                  var submitLabel = submitBtn.querySelector('.ce-product-form__label') || submitBtn.querySelector('span');
                  if (submitLabel) submitLabel.textContent = 'Add to Cart \u00b7 ' + formatMoney(matchedVariant.price);
                  var panelPrice = document.querySelector('.ce-purchase-panel__price span:last-child');
                  if (panelPrice) panelPrice.textContent = formatMoney(matchedVariant.price);
                } else {
                  submitBtn.disabled = true;
                  var soldOutLabel = submitBtn.querySelector('.ce-product-form__label') || submitBtn.querySelector('span');
                  if (soldOutLabel) soldOutLabel.textContent = 'Sold Out';
                }
              }

              /* Filter gallery images by color alt-text prefix */
              var mainImg = document.querySelector('.ce-gallery__main img');
              var thumbs = document.querySelectorAll('.ce-gallery__thumb');
              var colorLower = value.toLowerCase();

            var colorThumbs = [];
            thumbs.forEach(function(thumb) {
              var alt = (thumb.querySelector('img').alt || '').toLowerCase();
              if (alt.indexOf(colorLower) === 0) {
                colorThumbs.push(thumb);
              }
            });

            if (colorThumbs.length > 0 && mainImg) {
              var firstSrc = colorThumbs[0].getAttribute('data-full-src');
              if (firstSrc) mainImg.src = firstSrc;
              thumbs.forEach(function(t) { t.classList.remove('is-active'); });
              colorThumbs[0].classList.add('is-active');
            }

            if (matchedVariant.featured_image && mainImg) {
              mainImg.src = matchedVariant.featured_image.src.replace(/(\.[^.]+)$/, '_1400x1400$1');
            }

            document.dispatchEvent(new CustomEvent('ce:variant-change', {
              detail: { variant: matchedVariant }
            }));
          }
        }
      });
    });
    });
  }


  /* --- CART POPUP --- */
  function initCartPopup() {
    var popup = document.getElementById('CeCartPopup');
    if (!popup || popup.dataset.initialized === 'true') return popup;

    var panel = popup.querySelector('.ce-cart-popup__panel');
    var itemsContainer = popup.querySelector('#CeCartPopupItems');

    function closePopup() {
      popup.classList.remove('is-active');
      document.body.classList.remove('ce-cart-popup-open');
      window.setTimeout(function() {
        if (!popup.classList.contains('is-active')) popup.hidden = true;
      }, 220);
    }

    popup.querySelectorAll('[data-ce-cart-close]').forEach(function(trigger) {
      trigger.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && !popup.hidden) closePopup();
    });

    popup.openWithItems = function(items) {
      if (itemsContainer) {
        itemsContainer.innerHTML = items.map(function(item) {
          var subtitle = item.subtitle ? '<div class="ce-cart-popup__item-meta">' + escapeHTML(item.subtitle) + '</div>' : '';
          var quantity = item.quantity && item.quantity > 1 ? '<div class="ce-cart-popup__item-meta">Qty ' + escapeHTML(item.quantity) + '</div>' : '';
          var thumb = item.image
            ? '<div class="ce-cart-popup__item-thumb"><img src="' + escapeHTML(item.image) + '" alt="" loading="lazy"></div>'
            : '<div class="ce-cart-popup__item-thumb ce-cart-popup__item-thumb--empty"></div>';

          return '' +
            '<div class="ce-cart-popup__item">' +
              thumb +
              '<div class="ce-cart-popup__item-copy">' +
                '<div class="ce-cart-popup__item-title">' + escapeHTML(item.title) + '</div>' +
                subtitle +
                quantity +
              '</div>' +
              '<div class="ce-cart-popup__item-price">' + formatMoney((item.price || 0) * (item.quantity || 1)) + '</div>' +
            '</div>';
        }).join('');
      }

      popup.hidden = false;
      window.requestAnimationFrame(function() {
        popup.classList.add('is-active');
        document.body.classList.add('ce-cart-popup-open');
        if (panel) panel.focus();
      });
    };

    popup.closePopup = closePopup;
    popup.dataset.initialized = 'true';
    return popup;
  }


  /* --- ADDON BLOCK CLICKABLE --- */
  function initAddonClickable() {
    document.querySelectorAll('.ce-addon').forEach(function(addon) {
      var input = addon.querySelector('.ce-addon__input');
      if (!input) return;

      function syncSelectedState() {
        addon.classList.toggle('is-selected', !!input.checked);
      }

      addon.style.cursor = 'pointer';
      syncSelectedState();

      input.addEventListener('change', syncSelectedState);

      addon.addEventListener('click', function(e) {
        /* Let links behave natively without toggling the addon card. */
        if (e.target.closest('a')) return;

        /* Let nested controls such as the Onyx subscription selector work normally. */
        if (e.target.closest('select, option, button')) return;

        /* Native checkbox/label interactions will already toggle checked state. */
        if (e.target.closest('label, input')) {
          window.requestAnimationFrame(syncSelectedState);
          return;
        }

        input.checked = !input.checked;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }


  /* --- ONYX SOLUTION SUBSCRIPTION SELECTOR --- */
  function initSolutionAddonSelector() {
    document.querySelectorAll('.ce-addon--solution').forEach(function(addon) {
      var input = addon.querySelector('.ce-addon__input');
      var select = addon.querySelector('.ce-addon__solution-select');
      var name = addon.querySelector('.ce-addon__name strong');
      var price = addon.querySelector('.ce-addon__price');
      if (!input || !select) return;

      function syncSolutionVariant() {
        var option = select.options[select.selectedIndex];
        if (!option) return;

        input.setAttribute('data-addon-id', option.value);
        input.setAttribute('data-addon-title', option.getAttribute('data-title') || option.textContent.trim());
        input.setAttribute('data-addon-price', option.getAttribute('data-price') || input.getAttribute('data-addon-price') || '0');

        if (name) name.textContent = option.textContent.trim();
        if (price) price.textContent = '$39.99/year';
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      select.addEventListener('click', function(e) {
        e.stopPropagation();
      });
      select.addEventListener('change', syncSolutionVariant);
      syncSolutionVariant();
    });
  }


  /* --- DEV-ONLY COOKIE BANNER HIDE --- */
  function initDevHideCookieBanner() {
    var host = window.location.hostname;
    if (host !== '127.0.0.1' && host !== 'localhost') return;

    var styleId = 'ce-dev-hide-cookie-banner';
    var bannerSelectors = [
      '#shopify-pc__banner',
      '#shopify-pc__banner__dialog',
      '#shopify-pc__backdrop',
      '#shopify-privacy-banner',
      '.shopify-pc__banner',
      '.shopify-pc__banner__dialog',
      '.shopify-pc__backdrop'
    ];

    function ensureStyle() {
      if (document.getElementById(styleId)) return;

      var style = document.createElement('style');
      style.id = styleId;
      style.textContent = bannerSelectors.join(',\n') + ' { display: none !important; visibility: hidden !important; opacity: 0 !important; pointer-events: none !important; }';
      document.head.appendChild(style);
    }

    function clearModalLock() {
      document.documentElement.style.removeProperty('overflow');
      document.body.style.removeProperty('overflow');
    }

    function hideExisting() {
      bannerSelectors.forEach(function(selector) {
        document.querySelectorAll(selector).forEach(function(node) {
          node.style.display = 'none';
          node.style.visibility = 'hidden';
          node.style.opacity = '0';
          node.style.pointerEvents = 'none';
        });
      });

      clearModalLock();
    }

    ensureStyle();
    hideExisting();

    var observer = new MutationObserver(function() {
      hideExisting();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    window.setTimeout(hideExisting, 250);
    window.setTimeout(hideExisting, 1000);
    window.setTimeout(hideExisting, 2500);
  }


  /* --- QUANTITY SELECTOR --- */
  function initQuantity() {
    document.querySelectorAll('.ce-quantity').forEach(function(wrapper) {
      var input = wrapper.querySelector('.ce-quantity__input');
      var minus = wrapper.querySelector('.ce-quantity__btn--minus');
      var plus = wrapper.querySelector('.ce-quantity__btn--plus');
      if (!input) return;

      if (minus) {
        minus.addEventListener('click', function() {
          var val = parseInt(input.value, 10) || 1;
          if (val > 1) {
            input.value = val - 1;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      if (plus) {
        plus.addEventListener('click', function() {
          var val = parseInt(input.value, 10) || 1;
          input.value = val + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    });
  }


  /* --- PRODUCT FORM (Add to Cart via AJAX) --- */
  function initProductForm() {
    var form = document.querySelector('.ce-product-form');
    if (!form) return;

    var submitBtn = form.querySelector('.ce-product-form__submit');
    var submitLabel = submitBtn ? (submitBtn.querySelector('.ce-product-form__label') || submitBtn.querySelector('span')) : null;
    var variantInput = form.querySelector('[name="id"]');
    var quantityInput = form.querySelector('.ce-quantity__input');
    var stickyBtn = document.querySelector('.ce-sticky-atc .ce-btn-primary');
    var productTitle = document.querySelector('.ce-product-details__title');
    var addonInputs = document.querySelectorAll('.ce-addon__input');
    var productJSON = document.getElementById('PremiumProductJSON');
    var productData = productJSON ? JSON.parse(productJSON.textContent) : null;
    var isSubmitting = false;

    function getCurrentVariant() {
      if (!productData || !variantInput) return null;

      var selectedVariantId = parseInt(variantInput.value, 10);
      return productData.variants.find(function(variant) {
        return variant.id === selectedVariantId;
      }) || productData.selected_or_first_available_variant || null;
    }

    function getSelectedAddons() {
      var addons = [];

      addonInputs.forEach(function(input) {
        if (!input.checked) return;

        var addonId = parseInt(input.getAttribute('data-addon-id'), 10);
        if (!addonId) return;

        addons.push({
          id: addonId,
          price: parseInt(input.getAttribute('data-addon-price'), 10) || 0,
          quantity: 1,
          title: input.getAttribute('data-addon-title') || 'Upgrade',
          image: input.getAttribute('data-addon-image') || '',
          sellingPlan: parseInt(input.getAttribute('data-addon-selling-plan'), 10) || null
        });
      });

      return addons;
    }

    function updateButtonPrice() {
      var currentVariant = getCurrentVariant();
      var basePrice = currentVariant && typeof currentVariant.price === 'number' ? currentVariant.price : 0;
      var total = basePrice;

      getSelectedAddons().forEach(function(addon) {
        total += addon.price;
      });

      if (!submitBtn || !submitLabel) return;

      if (currentVariant && currentVariant.available === false) {
        submitBtn.disabled = true;
        submitLabel.textContent = 'Sold Out';
        if (stickyBtn) stickyBtn.disabled = true;
        return;
      }

      submitBtn.disabled = false;
      submitLabel.textContent = 'Add to Cart \u00b7 ' + formatMoney(total);
      var panelPrice = document.querySelector('.ce-purchase-panel__price span:last-child');
      if (panelPrice) panelPrice.textContent = formatMoney(total);
      if (stickyBtn) stickyBtn.disabled = false;
    }

    addonInputs.forEach(function(input) {
      input.addEventListener('change', updateButtonPrice);
    });

    document.addEventListener('ce:variant-change', updateButtonPrice);
    updateButtonPrice();

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      if (isSubmitting || !variantInput) return;

      var currentVariant = getCurrentVariant();
      if (!currentVariant) return;

      var mainQuantity = quantityInput ? Math.max(parseInt(quantityInput.value, 10) || 1, 1) : 1;
      var selectedAddons = getSelectedAddons();
      var mainImage = (currentVariant && currentVariant.featured_image && currentVariant.featured_image.src)
        || (productData && productData.featured_image)
        || (productData && productData.images && productData.images[0])
        || '';
      var items = [{
        id: currentVariant.id,
        quantity: mainQuantity,
        price: currentVariant.price || 0,
        title: productTitle ? productTitle.textContent.trim() : 'Humidor',
        subtitle: currentVariant.title && currentVariant.title !== 'Default Title' ? currentVariant.title : '',
        image: mainImage
      }];

      selectedAddons.forEach(function(addon) {
        items.push(addon);
      });

      isSubmitting = true;
      if (submitBtn) submitBtn.disabled = true;
      if (stickyBtn) stickyBtn.disabled = true;
      if (submitLabel) submitLabel.textContent = 'Adding...';

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: items.map(function(item) {
            var payloadItem = {
              id: item.id,
              quantity: item.quantity
            };

            if (item.sellingPlan) {
              payloadItem.selling_plan = item.sellingPlan;
            }

            return payloadItem;
          })
        })
      })
      .then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok) {
            throw new Error(data.description || data.message || 'Add to cart failed');
          }

          return data;
        });
      })
      .then(function() {
        if (submitLabel) submitLabel.textContent = 'Added';

        /* Update cart count in header */
        var cartCount = document.querySelector('.ce-header__cart-count');
        if (cartCount) cartCount.classList.add('has-items');

        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      })
      .catch(function(err) {
        console.error('Cart error:', err);
        if (submitLabel) submitLabel.textContent = 'Error — Try Again';
        window.setTimeout(updateButtonPrice, 2000);
      })
      .finally(function() {
        isSubmitting = false;
        if (stickyBtn && (!submitBtn || !submitBtn.disabled)) stickyBtn.disabled = false;
      });
    });

    /* Sticky ATC form mirror */
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function(e) {
        e.preventDefault();
        form.dispatchEvent(new Event('submit', { bubbles: true }));
      });
    }
  }


  /* --- INIT ALL --- */
  function init() {
    initScrollReveals();
    initHeader();
    initDevHideCookieBanner();
    initGallery();
    initFeatureScrollSwap();
    initSwatches();
    initCartPopup();
    initStickyATC();
    initMobileMenu();
    initQuantity();
    initAddonClickable();
    initSolutionAddonSelector();
    initProductForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
